import Image from "next/image";
import { type ColorScheme, COLOR_SCHEMES } from "@/lib/colorSchemes";
import { cn } from "@/lib/utils";

export interface IconListItem {
  iconSrc: string;
  iconAlt?: string;
  boldText?: string;
  text?: string;
}

export interface IconListProps {
  items: IconListItem[];
  columns?: 1 | 2 | 3;
  colorScheme?: ColorScheme;
}

export function IconList({
  items,
  columns = 1,
  colorScheme = "default",
}: IconListProps) {
  if (!items || items.length === 0) return null;

  const scheme = COLOR_SCHEMES[colorScheme];

  const gridClass =
    columns === 3
      ? "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8"
      : columns === 2
        ? "grid grid-cols-1 sm:grid-cols-2 gap-6"
        : "flex flex-col gap-4";

  return (
    <div className={gridClass}>
      {items.map((item, i) => (
        <div key={i} className="flex items-start gap-4">
          {item.iconSrc && (
            <div className="shrink-0">
              <Image
                src={item.iconSrc}
                alt={item.iconAlt ?? ""}
                width={40}
                height={40}
                loading="eager"
                className="size-10"
              />
            </div>
          )}
          <div className="min-w-0">
            {item.boldText && (
              <p className={cn("text-body-md font-semibold", scheme.heading)}>
                {item.boldText}
              </p>
            )}
            {item.text && (
              <p className={cn("text-body-sm", scheme.body)}>{item.text}</p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

export default IconList;
